import { createSlice, PayloadAction, createAction } from '@reduxjs/toolkit';
import { WeeklyPlan } from '@/services/learningProgress';

// Async actions for saga
export const fetchWeeklyPlan = createAction<{ weekNumber: number }>('weeklyPlan/fetchWeeklyPlan');
export const fetchWeeklyPlanSuccess = createAction<WeeklyPlan>('weeklyPlan/fetchWeeklyPlanSuccess');
export const fetchWeeklyPlanFailure = createAction<string>('weeklyPlan/fetchWeeklyPlanFailure');

export interface WeeklyPlanState {
    currentPlan: WeeklyPlan | null;
    plans: WeeklyPlan[];
    isLoading: boolean;
    error: string | null;
    lastUpdated: string | null;
}

const initialState: WeeklyPlanState = {
    currentPlan: null,
    plans: [],
    isLoading: false,
    error: null,
    lastUpdated: null,
};

const weeklyPlanSlice = createSlice({
    name: 'weeklyPlan',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
        resetState: () => initialState,
        setCurrentPlan: (state, action: PayloadAction<WeeklyPlan>) => {
            state.currentPlan = action.payload;
        },
        addPlan: (state, action: PayloadAction<WeeklyPlan>) => {
            const existingIndex = state.plans.findIndex((plan) => plan.id === action.payload.id);
            if (existingIndex >= 0) {
                state.plans[existingIndex] = action.payload;
            } else {
                state.plans.push(action.payload);
            }
        },
    },
    extraReducers: (builder) => {
        // Fetch Weekly Plan
        builder
            .addCase(fetchWeeklyPlan, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchWeeklyPlanSuccess, (state, action) => {
                state.isLoading = false;
                state.currentPlan = action.payload;
                state.lastUpdated = new Date().toISOString();
                state.error = null;

                // Add to plans array if not exists
                const existingIndex = state.plans.findIndex((plan) => plan.id === action.payload.id);
                if (existingIndex >= 0) {
                    state.plans[existingIndex] = action.payload;
                } else {
                    state.plans.push(action.payload);
                }
            })
            .addCase(fetchWeeklyPlanFailure, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    },
});

export const { clearError, resetState, setCurrentPlan, addPlan } = weeklyPlanSlice.actions;

export default weeklyPlanSlice.reducer;
